import React from 'react';
import { Counter, useClassnames } from '@wb-tech/ui-react';

import { useGetApiV1NewsCountQuery } from '#adapter/api/campaigns/v1/news/count';

import style from './index.module.pcss';

const MAX_COUNTER_VALUE = 99;

interface INewsCounter {
    setNewsCount: (counter: number) => void
}

export const NewsCounter = ({ setNewsCount }: INewsCounter) => {
    const { data } = useGetApiV1NewsCountQuery({});

    const counter = data?.count;

    const cn = useClassnames(style);

    if(!counter) {
        return null;
    }
    setNewsCount(counter);

    return (
        <Counter className={cn('news-counter')}>
            {counter <= MAX_COUNTER_VALUE ? counter : `${MAX_COUNTER_VALUE}+`}
        </Counter>
    );
};
